import React, {useCallback, useEffect, useState} from "react";
import "./add-edit-user.scss";

import {GSForm, GSSidePanelPage} from "golfstatus_react_components";
import {faChevronLeft, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {useMatch, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {selectCurrentOrganization} from "../../reducers/organizationSlice";

import {
  addOrganizationUser,
  clearNotifications,
  getOrganizationUser,
  selectMember,
  selectUsersNotifications,
  setMember,
} from "../../reducers/userSlice";

import {addUserForm} from "../../forms/OrganizationForm";
import MemberLineItem from "./member-line-item";

const AddUser = () => {
  const [isValid, setIsValid] = useState(false);
  
  const [user, setUser] = useState({
    email: "",
    organization: "",
    permissionType: { id: 1, label: "Organization Member", value: 1 },
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/permissions/:memberID/*");
  const { id, memberID } = matchEdit.params;

  const orgNotifications = useSelector(selectUsersNotifications);
  const currentOrganization = useSelector(selectCurrentOrganization);
  const currentMember = useSelector(selectMember);

  const loadMember = useCallback(() => {
    if (matchEdit?.params?.memberID !== "add") {
      if (matchEdit?.params?.["*"] === "edit-member") {
        dispatch(getOrganizationUser(matchEdit?.params?.memberID));
      }
    } else {
      const newMember = {
        email: "",
        organization: "",
        permissionType: { id: 1, label: "Organization Member", value: 1 },
      };
      setMember(newMember)
    }
  }, [dispatch, matchEdit?.params]);

  useEffect(() => {
    loadMember();
    return () => {
      const newMember = {
        email: "",
        organization: "",
        permissionType: { id: 1, label: "Organization Member", value: 1 },
      };
      dispatch(setMember(newMember));
    };
  }, [loadMember, dispatch]);

  useEffect(() => {
    const { id, memberID } = matchEdit?.params;

    if (currentMember?.id) {
      if (currentMember?.id !== memberID) {
        navigate(`/${id}/permissions/${currentMember.id}/edit-member`);
      }
      let member = { ...currentMember };
      member.permissionType = { id: 1, value: 1 };
      setUser(member);
    }
  }, [currentMember, matchEdit?.params, navigate]);

  let context = {};
  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };
  context.updateUser = (value, property) => {
    setIsValid(true);
    let usr = { ...user };
    usr[property] = value;
    setUser(usr);
  };

  context.isMember = () => {
    return user?.permissionType?.id === 1;
  };

  context.isEditable = () => {
    return matchEdit?.params?.memberID === "add";
  };

  context.permissionInfo = () => {
    navigate(`/${id}/permissions/type-info`);
  };

  const addMember = () => {
    setIsValid(false);
    let invite = {
      email: user.email,
      organization: currentOrganization,
      role: user.permissionType.value,
    }
    dispatch(addOrganizationUser(invite));
  };

  const deleteMember = () => {
    navigate(`/${id}/permissions/${memberID}/delete-member`);
  };

  const leftNavigation = () => {
    dispatch(clearNotifications());
    const { id } = matchEdit?.params;
    navigate(`/${id}/permissions`);
  };
  const getActions = () => {
    let actions = [];

    if (context?.isEditable?.()) {
      actions.push?.({
        name: "Save",
        isDisabled: !isValid,
        action: addMember,
        type: "black",
      });
      actions.push?.({
        name: "cancel",
        action: leftNavigation,
        type: "grey",
      });
    } else {
      actions?.push?.({
        name: "Delete User",
        action: deleteMember,
        type: "transparent red",
      });
    }
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "User Details",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };
  const timeoutAction = () => {
    dispatch(clearNotifications());
  };
  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "View User List",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  const getFormSections = () => {
    if (context.isEditable()) {
      return addUserForm(context, user);
    }

    return [
      {
        type: "vertical xx-large-gap",
        fields: [
          {
            value: (<MemberLineItem {...currentMember} />),
            customView: true,
          },
        ],
      }
    ];
  };

  const getFormActions = () => {
    if (context.isEditable()) {
      return [{
        buttonTitle: "Permission Types",
        type: "grey mobile-icon",
        actionIcon: faInfoCircle,
        actionClick: () => context.permissionInfo(),
      }];
    }

    return [];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={context.isEditable() ? "Add User" : "Edit User"}
        formSections={getFormSections()}
        formActions={getFormActions()}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <add-edit-user>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </add-edit-user>
  );
};

export default AddUser;
